import Vue from 'vue';

import { Button,Icon } from 'vant';
import { Tab, Tabs } from 'vant';
import { Field } from 'vant';

import { ActionSheet } from 'vant';
import { Col, Row } from 'vant';
import { Divider } from 'vant';
import { Grid, GridItem } from 'vant';
import { Tag } from 'vant';
import { Image as VanImage } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Dialog } from 'vant';
import { Stepper } from 'vant';
import { List } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Form } from 'vant';

Vue.use(Form);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(List);
Vue.use(Stepper);
Vue.use(Dialog);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VanImage);
Vue.use(Tag);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Divider);
Vue.use(Col);
Vue.use(Row);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);